import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Huntsville, AL?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through the Huntsville Main Post Office can take 2–6 months. For Redstone Arsenal contractors with TDY orders, NASA Marshall engineers with international conference deadlines, and UAH students with study abroad programs, that timeline is simply not viable.",
  },
  {
    q: "Can Redstone Arsenal employees and contractors get expedited passports?",
    a: "Absolutely. Redstone Arsenal employs over 40,000 military personnel, civilian contractors, and defense industry workers. These professionals receive TDY orders, deployment notifications, and international assignment changes on short notice — sometimes with just days before a flight to Germany, Korea, or the Middle East. We regularly process expedited renewals, new applications, and dependent passports for Arsenal personnel on compressed timelines.",
  },
  {
    q: "Does NASA Marshall Space Flight Center have a passport office?",
    a: "NASA Marshall does not operate a dedicated passport acceptance office. Marshall engineers collaborate with ESA, JAXA, and private space companies worldwide, and conference trips, training rotations, and partnership visits happen year-round. The closest acceptance facility is the Huntsville Main Post Office. For urgent travel, our registered courier service provides the fastest path to a valid passport.",
  },
  {
    q: "Where is the Huntsville passport acceptance facility?",
    a: "The Huntsville Main Post Office serves as the primary passport acceptance facility. The Madison Post Office also accepts applications with photo service available. Hours are typically Monday–Friday 9:00 AM–4:00 PM. However, these facilities only accept applications — they do not process expedited or emergency requests.",
  },
  {
    q: "Can UAH students get expedited passports for study abroad and Space Camp exchanges?",
    a: "Yes. The University of Alabama in Huntsville has strong international partnerships, and students participate in study abroad programs, international robotics competitions, and aerospace research exchanges. Space Camp at the U.S. Space and Rocket Center brings thousands of international students to Huntsville annually, and many local families reciprocate by sending their children abroad. We help UAH and Space Camp families with fast processing.",
  },
  {
    q: "How quickly can Madison, Decatur, and Athens residents receive expedited passports?",
    a: "Madison, Decatur, Athens, Meridianville, and Harvest residents have the same access to our expedited services as Huntsville residents. Since we operate remotely, your location in the Tennessee Valley does not affect processing speed. Most clients receive their passports within 2–9 business days.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Huntsville travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Huntsville, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Tennessee Valley.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. Military and defense contractor personnel may have additional documentation requirements. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability. As a registered courier, we offer rates typically 30–100% lower than FedEx, Staples, and other third-party resellers.",
  },
];

export default function HuntsvilleFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Huntsville and Tennessee Valley travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}